import { render, staticRenderFns } from "./ResourceRolesAndExceptionsInfoTemplate.vue?vue&type=template&id=6d88f5eb&scoped=true&"
import script from "./ResourceRolesAndExceptionsInfoTemplate.vue?vue&type=script&lang=ts&"
export * from "./ResourceRolesAndExceptionsInfoTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceRolesAndExceptionsInfoTemplate.vue?vue&type=style&index=0&id=6d88f5eb&scoped=true&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6d88f5eb",
  null
  
)

export default component.exports